var map = {
	"./squash0.jpg": 9983,
	"./squash1.jpeg": 5871,
	"./squash2.jpg": 221,
	"./squash3.jpeg": 4473,
	"./squash5.jpeg": 4355,
	"./squash91.jpeg": 9722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4707;